import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

import { Observable } from 'rxjs';
import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';

import { MediaQueryService, TestVariant } from '@fcom/common';
import { TagTheme } from '@fcom/ui-components';
import {
  DestinationSearchItem,
  DestinationSearchItemFilterSelection,
  FilterAction,
} from '@fcom/destination-search/interfaces';

@Component({
  selector: 'fin-destination-search-filter-chips',
  templateUrl: 'destination-search-filter-chips.component.html',
})
export class DestinationSearchFilterChipsComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly TagTheme = TagTheme;
  readonly TestVariant = TestVariant;
  readonly cmsStylesOverride = {
    'padding-bottom': '0',
  };

  isMobile$: Observable<boolean>;

  @Input()
  selectedDestinations: DestinationSearchItem[];

  @ViewChild('tagsList', { static: false })
  tagsList: ElementRef;

  @ViewChild('a11yHeading', { static: false })
  a11yHeading: ElementRef;

  @Output()
  tagRemove = new EventEmitter<DestinationSearchItemFilterSelection>();

  constructor(private mediaQueryService: MediaQueryService) {
    this.isMobile$ = this.mediaQueryService.isBreakpoint$('mobile');
  }

  removeAll(): void {
    this.tagRemove.emit({
      action: FilterAction.REMOVE_ALL,
      destination: undefined,
      selectedDestinations: this.selectedDestinations,
    });
  }

  trackByFn(_index: number, item: DestinationSearchItem): string {
    return item.id;
  }

  removeChip(destination: DestinationSearchItem): void {
    this.tagRemove.emit({
      action: FilterAction.REMOVE,
      destination,
      selectedDestinations: this.selectedDestinations,
    });

    // setTimeout due to DOM operation
    setTimeout(() => {
      const buttons = this.tagsList.nativeElement.querySelectorAll('button');
      if (buttons.length) {
        buttons[buttons.length - 1].focus();
      } else {
        this.a11yHeading.nativeElement.focus();
      }
    }, 0);
  }
}
